$(document).on('focus click', 'textarea.autoexpand_on_focus', function () {
  return $(this).autosize();
});